import { useState } from 'react';
import { ApiError } from '../api/client';
import { Alert, Button, Card, Field, Input, PasswordInput } from '../components/ui';
import { useT } from '../i18n/locale';
import { useAdminSession } from './session';

export default function AdminLogin() {
  const { login } = useAdminSession();
  const t = useT();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t('admin.loginFailed'));
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 p-4">
      <Card className="w-full max-w-sm p-6">
        {/*
          Visually unlike the customer login on purpose. Someone who lands here
          by following an old bookmark should see immediately that this is not
          the app they meant to open.
        */}
        <h1 className="m-0 text-lg font-black text-slate-900">{t('admin.loginTitle')}</h1>
        <p className="mt-1 mb-5 text-sm text-slate-500">{t('admin.loginSubtitle')}</p>

        <form onSubmit={submit} className="flex flex-col gap-3">
          {error ? <Alert tone="error">{error}</Alert> : null}
          <Field label={t('common.email')}>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              autoComplete="username"
            />
          </Field>
          <Field label={t('common.password')}>
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </Field>
          <Button type="submit" disabled={busy || !email || !password}>
            {busy ? t('admin.checking') : t('admin.signIn')}
          </Button>
        </form>
      </Card>
    </div>
  );
}
